import { publicHeaderRequest, publicRequest } from '../requestMethods/requestMethods';

const POPUP_ADMIN_BASE = '/admin/popup';
const POPUP_ADMIN_EMAIL_TEMPLATE = `${POPUP_ADMIN_BASE}/email-template`;
const POPUP_PUBLIC_SUBSCRIBE = '/popup/subscribe';

const getApiErrorMessage = (error, fallbackMessage) => {
  const apiMessage = error?.response?.data?.message;
  if (apiMessage) {
    return apiMessage;
  }

  if (error?.message) {
    return error.message;
  }

  return fallbackMessage;
};

async function getAdminPopupConfig() {
  try {
    const response = await publicRequest.get(POPUP_ADMIN_BASE);
    return response.data;
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'No fue posible obtener la configuración del popup.'));
  }
}

async function updateAdminPopupConfig(payload) {
  try {
    const response = await publicRequest.put(POPUP_ADMIN_BASE, payload);
    return response.data;
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'No fue posible actualizar la configuración del popup.'));
  }
}

async function uploadAdminPopupThumbnail(file) {
  const formData = new FormData();
  formData.append('file', file);

  try {
    const response = await publicHeaderRequest.post(`${POPUP_ADMIN_BASE}/thumbnail`, formData);
    return response.data;
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'No fue posible subir la imagen del popup.'));
  }
}

async function getPopupSubscribers({ page = 0, size = 20, sort = 'subscribedAt,desc' } = {}) {
  try {
    const response = await publicRequest.get(`${POPUP_ADMIN_BASE}/subscribers`, {
      params: {
        page,
        size,
        sort,
      },
    });

    return response.data;
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'No fue posible obtener suscriptores del popup.'));
  }
}

async function deletePopupSubscriber(subscriberId) {
  try {
    await publicRequest.delete(`${POPUP_ADMIN_BASE}/subscribers/${subscriberId}`);
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'No fue posible eliminar la suscripción.'));
  }
}

async function resendPopupSubscriberEmail(subscriberId) {
  try {
    const response = await publicRequest.post(`${POPUP_ADMIN_BASE}/subscribers/${subscriberId}/resend-email`);
    return response.data;
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'No fue posible reenviar el correo promocional.'));
  }
}

async function getAdminPopupEmailTemplate() {
  try {
    const response = await publicRequest.get(POPUP_ADMIN_EMAIL_TEMPLATE);
    return response.data;
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'No fue posible obtener la plantilla de correo del popup.'));
  }
}

async function updateAdminPopupEmailTemplate(payload) {
  try {
    const response = await publicRequest.put(POPUP_ADMIN_EMAIL_TEMPLATE, payload);
    return response.data;
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'No fue posible actualizar la plantilla de correo del popup.'));
  }
}

/**
 * @param {string} email
 * @param {string | null | undefined} [promotionId]
 */
async function subscribePopupEmail(email, promotionId = null) {
  const payload = {
    email,
    ...(promotionId ? { promotionId } : {}),
  };

  try {
    const response = await publicRequest.post(POPUP_PUBLIC_SUBSCRIBE, payload);
    return response.data;
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'No fue posible suscribir el correo.'));
  }
}

export {
  getAdminPopupConfig,
  getAdminPopupEmailTemplate,
  updateAdminPopupConfig,
  updateAdminPopupEmailTemplate,
  uploadAdminPopupThumbnail,
  getPopupSubscribers,
  deletePopupSubscriber,
  resendPopupSubscriberEmail,
  subscribePopupEmail,
};
